// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9cbb4955","866":"3d163a6e"}[chunkId] + ".chunk.js";
};